import { gql } from '@apollo/client';

export const ALL_COMMUNITY_TYPES = gql`
  query getCommunityTypes {
    communityTypes: getCommunityTypes {
      id
      name
    }
  }
`;
